export interface PlaygroundMethodSpec {
  value: string;
  group: string;
  argsTemplate: Record<string, unknown>;
  note?: string;
}

export const PLAYGROUND_METHODS: PlaygroundMethodSpec[] = [
  { value: 'validateCredentials', group: 'Auth & status', argsTemplate: {} },
  { value: 'getRateLimitStatus', group: 'Auth & status', argsTemplate: {} },
  { value: 'getAvailableObjects', group: 'Metadata', argsTemplate: {} },
  { value: 'getAllAvailableObjects', group: 'Metadata', argsTemplate: {} },
  {
    value: 'getHierarchyMetadata',
    group: 'Metadata',
    argsTemplate: {},
    note: 'Only for hierarchy integrations (Slack, Notion, Airtable).',
  },
  { value: 'getGlobalMetadata', group: 'Metadata', argsTemplate: {} },
  { value: 'getObjectMetadata', group: 'Metadata', argsTemplate: { objectType: '' } },
  { value: 'getObjectFields', group: 'Metadata', argsTemplate: { objectType: '' } },
  { value: 'getObjectRelationshipTypes', group: 'Metadata', argsTemplate: { objectType: '' } },
  {
    value: 'getFieldPicklistValues',
    group: 'Metadata',
    argsTemplate: { objectType: '', field: '' },
  },
  { value: 'getIdFieldName', group: 'Metadata', argsTemplate: { objectType: '' } },
  {
    value: 'getDateFieldName',
    group: 'Metadata',
    argsTemplate: { objectType: '', dateType: 'updatedAt' },
  },
  {
    value: 'getItemBrowserLink',
    group: 'Items',
    argsTemplate: { objectType: '', objectId: '' },
  },
  { value: 'getObject', group: 'Items', argsTemplate: { objectType: '', objectId: '' } },
  {
    value: 'getObjectsByIds',
    group: 'Items',
    argsTemplate: { objectType: '', ids: [] },
    note: 'Max 50 ids.',
  },
  {
    value: 'getRelatedEntities',
    group: 'Items',
    argsTemplate: { objectType: '', objectId: '', relationshipType: '' },
  },
  {
    value: 'list',
    group: 'Items',
    argsTemplate: {
      objectType: '',
      fromDate: '',
      toDate: '',
      dateField: 'updatedAt',
      maxItems: 50,
    },
    note: 'Returns per-page diagnostics. Range ≤ 31 days, maxItems ≤ 200.',
  },
  {
    value: 'count',
    group: 'Items',
    argsTemplate: { objectType: '', fromDate: '', toDate: '', dateField: 'updatedAt' },
    note: 'Not supported by all clients.',
  },
  {
    value: 'getDeletedItems',
    group: 'Items',
    argsTemplate: { objectType: '', fromDate: '', toDate: '' },
    note: 'Optional per client.',
  },
  {
    value: 'listOptions',
    group: 'Data-out helpers',
    argsTemplate: { fieldType: '' },
    note: 'Optional per client.',
  },
  {
    value: 'searchOption',
    group: 'Data-out helpers',
    argsTemplate: { fieldType: '', query: '' },
    note: 'Optional per client.',
  },
  { value: 'listUsers', group: 'Data-out helpers', argsTemplate: {}, note: 'Optional per client.' },
];

export function getMethodSpec(method: string): PlaygroundMethodSpec | undefined {
  return PLAYGROUND_METHODS.find((spec) => spec.value === method);
}
